"use client"

import { PanelTopOpen } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `PanelTopOpenIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const PanelTopOpenIcon = component(Icon)({ as: PanelTopOpen })
